module.exports = __webpack_public_path__ + "img/h_product_71.b88d74b.jpg";